import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../../../../services/endpoints/endpoints.service";
import { PatientTag } from "../../../../models/endpoints/tags-endpoint.model";

export const useParticipantTags = ({ patientId }: { patientId: number }) => {
	const queryClient = useQueryClient();
	const queryKey = ["participant-tags", { patientId }];

	const query = useQuery({
		queryKey: queryKey,
		queryFn: async (): Promise<PatientTag[]> => {
			const response = await EndpointsService.dataRetriever.getParticipantTags({
				participantId: patientId,
			});
			return response;
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
